"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductInfoDialogProducts = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../../queries-net");
var _mappers = require("../mappers");
// istanbul ignore file @preserve -- api

const getProductInfoDialogProducts = async ({
  customerTypeId,
  graphQlUrl,
  productCodes,
  headers
}) => {
  const data = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.getProducts,
    url: graphQlUrl,
    variables: {
      productCodes
    },
    headers
  });
  return data.products ? (0, _mappers.mapProductsFromGql)({
    customerTypeId,
    isSubscriptionEnabled: data.application?.productDetailPage?.configuration?.isSubscriptionEnabled ?? false,
    products: data.products
  }) : [];
};
exports.getProductInfoDialogProducts = getProductInfoDialogProducts;
